import { render, staticRenderFns } from "./BaseAddress.vue?vue&type=template&id=01f8eedb&scoped=true&"
import script from "./BaseAddress.vue?vue&type=script&lang=js&"
export * from "./BaseAddress.vue?vue&type=script&lang=js&"
import style0 from "./BaseAddress.vue?vue&type=style&index=0&id=01f8eedb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../fodchef/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f8eedb",
  null
  
)

export default component.exports